import React, {useEffect, useContext} from 'react';
import { CalendarReportsContext } from '../context/CalendarReportsProvider';
import Spinner from '../../components/UI/Spinner/Spinner';
import Model from '../../components/UI/Modal/Model';
import IdleTimerContainer from '../../containers/IdleTimer/IdleTimerContainer';
import { ReportsProvider } from '../context/ReportsProvider';
import ReportsChartContainer from '../container/ReportsChartContainer';
import styled from 'styled-components';
import DisplayCalendar from '../../containers/Calendar/DisplayCalendar';
import { format } from 'date-fns';
import { LanguageContext } from "../../containers/Language/LanguageProvider";
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { enGB, fr, nl, de } from 'date-fns/locale';

function ReportsContainer(props) {

    const Separator = styled.div`
    clear: both;
    position: relative;
    margin: .01rem 0;
    background-color: #ddd;
    height: 2px;
    `;    

    const { idleTimeoutLimit, sessionTimeoutLimit, isLoading, showModel, errorMessage, isError, minDate,
         maxDate, modelHeaderTitle, resetSubmittedAndErrorFlags} = useContext(CalendarReportsContext);  
    const localeList = [enGB, fr, nl, de];
    const languageContext = useContext(LanguageContext);
    useEffect(() => {
        const selectedLanguage = languageContext && languageContext.language;
        if (selectedLanguage) {
            const selectedLangId = parseInt(selectedLanguage.id);
            registerLocale(selectedLanguage.text, localeList[selectedLangId - 1]);
            setDefaultLocale(selectedLanguage.text);
        }
    }, [languageContext.language.id]);
    return (
        <>
            <div className="sidebar-bottomcontent-container-col">
                <div style={{height:"49.8vh"}}></div>
                    <div>
                        <Separator />
                        <DisplayCalendar
                            selectedDate={format(new Date(), "dd/MM/yyyy")}
                            minDate={minDate}
                            maxDate={maxDate}/>
                    </div>                
            </div>
            <div className="sidebar-bottomcontent-container-next-col">
                    <div className="main-contents">
                        <div className="main-content"> 
                            <div className="nmbs-main">
                                <ReportsProvider 
                                    isLogout={props.isLogout}
                                    onLogoutClick={props.onLogoutClick}
                                    clearSessionData={props.clearSessionData} >
                                    <ReportsChartContainer
                                        isLogout={props.isLogout}
                                        onLogoutClick={props.onLogoutClick}
                                        clearSessionData={props.clearSessionData}
                                    />
                                </ReportsProvider>
                            </div>
                        </div>
                    </div>
            </div> 
            {   
                <Model showModel={showModel}
                    onHideHandler={resetSubmittedAndErrorFlags}
                    showHeader={showModel}
                    headerTitle={modelHeaderTitle}
                    showError={isError}
                    errorMessage={errorMessage}
                    isMonthlyIntakeBook={false}
                    isBusinessPartner={false}
                    showInstructions={undefined}
                    handleConfirmationYesClick={undefined}
                    showSuccess={undefined} 
                    successMessage= {undefined}
                />
            }           
            {isLoading ? <Spinner isLogin = {true}/> : undefined}                 
            {sessionTimeoutLimit && idleTimeoutLimit && <IdleTimerContainer idleTimeoutLimit={1000 * idleTimeoutLimit}
                                    sessionTimeoutLimit={1000 * sessionTimeoutLimit}
                                    logout={props.onLogoutClick} />}
        </>
    );
}

export default ReportsContainer;